export const itemSorterFn = orderMap => item => orderMap[item.dataKey] ?? Number.MAX_SAFE_INTEGER;
